export default __webpack_public_path__ + "static/media/cert-senior-manager-cpttm-sc.c1c0d965.jpg";